import { Injectable } from '@angular/core';
import { ModelService } from './model.service';
import { AwareHttpService } from '@appbolaget/aware-http';
import { Role } from '@appbolaget/aware-model';
import { Config } from '@services/config';

@Injectable()
export class RoleService extends ModelService<Role> {
    model: Role = new Role();

    constructor(
        public api: AwareHttpService,
        public config: Config,
    ) {
        super(api);
    }
}
